import React from "react";
import useSWR from "swr";
import { Events } from "../components/events/events";
import { Hero } from "../components/events/hero";
import styled from "@emotion/styled";
import { Page } from "../components/common/Page";

const StyledEventsContainer = styled.div`
  max-width: 1080px;
  margin: auto;
  padding: 0 1rem;
  transition: 0.4s all ease;
`;

export default () => {
  const { data: cityData, error: cityError } = useSWR("cities.json");
  if (cityError) {
    console.error("Error fetching cities");
  }

  return (
    <Page title="Let's TAP it">
      <StyledEventsContainer>
        <Hero />
        <Events cities={cityData?.cities} />
      </StyledEventsContainer>
    </Page>
  );
};
